import { Navigation } from "./navigation";
import { Helpers } from "./helpers/helpers";
import { MobileHelpers } from "./helpers/mobile-helpers";
import Cookies, {CookieAttributes} from "js-cookie";
import {ConsentCookie} from "./consent-banner";
import {FormHelpers} from "./helpers/form-helpers";

export class Header {	
	mainHeader: Element;
	searchForm: Element;
	searchBox: HTMLFormElement;
	mobileSearchButton: Element;
	mobileSearchContainer: Element;
	languageSelectors: NodeListOf<Element>;
	cultureDetectionViolators: NodeListOf<Element>;
	private cultureDetectionViolatorsWrap: HTMLElement;
	private searchBanner: HTMLElement;
	private mainSearchToggle: NodeListOf<Element>;
	private _searchOutsideClickListener: ((e: MouseEvent) => void) | null = null;
	private _searchScrollListener: (() => void) | null = null;
	constructor(bindEvents = false) {
		this.mainHeader = document.querySelector('.main-header');
		this.mainSearchToggle = document.querySelectorAll('.search-toggle');
		this.searchBanner = document.querySelector('.search-banner');
		this.searchForm = document.querySelector('.header-search-form');
		this.searchBox = document.querySelector('.header-search-form input');
		this.mobileSearchButton = document.querySelector('header .mobile-search a');
		this.mobileSearchContainer = document.querySelector('.mobile-search-form');
		this.languageSelectors = document.querySelectorAll('.language-selector');
		this.cultureDetectionViolatorsWrap = document.querySelector('.mobile-culture-detector');
		this.cultureDetectionViolators = document.querySelectorAll('.culture-detection-violator');

		if (bindEvents) {
			this.bindEvents();
		}
	}

	bindEvents(): void {

		// Close search when mega menu is hovered
		document.querySelectorAll('.main-nav .navigation > li').forEach(item => {
			item.addEventListener('mouseenter', () => {
				if (this.mainHeader.classList.contains('search-open')) {
					this.closeSearchBox();
				}
			});
		});

		//bind live chat trigger 
		document.querySelectorAll('.live-chat-trigger').forEach(element=> {
			element.addEventListener('click', (e)=>{
				e.preventDefault();
				
				if (window.LiveChatWidget) {
					window.LiveChatWidget.call("maximize");
				}
			})
		})
		//bind desktop search
		this.mainSearchToggle?.forEach(s=>
			s.addEventListener('click', (e) => {
			
			e.preventDefault();
			this.openHeaderSearchBox(true);
			return false;
		}));

		//bind mobile search 
		this.mobileSearchButton?.addEventListener('click', (e) => {
			e.preventDefault();
			this.mobileSearchContainer.classList.toggle('open');
			const navigation = new Navigation();
			navigation.closeExpandedNavigation();
		});

		//bind country selector
		if (!Helpers.isNullOrUndefined(this.languageSelectors)) {
			this.languageSelectors.forEach(languageSelector => {


				const optionsToggle = languageSelector.querySelector('.options-toggle');
				const languageOptions = languageSelector.querySelector('.language-options') as HTMLElement;
				const languageOptionsSelection = languageSelector.querySelector('.language-option-selection') as HTMLElement;
				const languageAccordion = languageSelector.querySelector('.language-accordian') as HTMLElement;
			optionsToggle?.addEventListener('click', () => {
				optionsToggle.classList.toggle('active');
				languageOptions.classList.toggle('open');
			});

				if (!Helpers.isNullOrUndefined(languageOptionsSelection)) {
					languageOptions.querySelectorAll('li > a').forEach(option => {
						option.addEventListener('click',
							(e) => {
								e.preventDefault();
								languageOptions.querySelectorAll('li').forEach(aEl => aEl.classList.remove('active'));
								const a = e.target as HTMLElement;
								a.closest('li').classList.add('active');
								languageOptionsSelection.innerHTML = a.parentNode.querySelector('.options').innerHTML;
							});
					});
				}

				if (!Helpers.isNullOrUndefined(languageAccordion)) {
					const accordians = languageAccordion.querySelectorAll('.accordian-item');
					const accordianToggles = languageAccordion.querySelectorAll('li > a');
					accordianToggles.forEach(option => {
						console.log('a toggle');
						option.addEventListener('click',
							(e) => {
								e.preventDefault();
								accordians.forEach(element => {
									element.classList.remove('active');
									element.querySelector('.options').classList.remove('active');
								});
							
								option.parentElement.classList.add('active');
								option.parentElement.querySelector('.options').classList.add('active');
							});
					});
				}
			});
			
			//bind culture violator detection
			const cookieKey = "hide-violator";
			const disableCultureViolated = true;
			let cookie = Cookies.get(cookieKey);			
			
			
			if (!cookie && !disableCultureViolated) {

				FormHelpers.getAjax(`/culture/detect?t=${new Date().getTime()}`, response => {
					const cultureInfo = JSON.parse(response) as any;					;
					
					if (!cultureInfo.cultureDetectionEnabled) return;
					
					if (cultureInfo && cultureInfo.cultureName && cultureInfo.cultureCode !== Helpers.getCurrentCulture() 
						|| (cultureInfo.cultureCode === "en-US" && window.location.host.indexOf('tensarinternational.com') !== -1)) {

						const pagesToSkipViolator = ["/dop"];
						if (pagesToSkipViolator.indexOf(window.location.pathname) !== -1) return;

						this.cultureDetectionViolatorsWrap.classList.remove('d-none');
						this.cultureDetectionViolators.forEach(violator => {							
							violator.querySelectorAll('.user-culture')
								.forEach(c => c.innerHTML = cultureInfo.countryName);				
							violator.querySelectorAll('.accept')
								.forEach(c => c.setAttribute("href",cultureInfo.url));
							
							violator.classList.remove('d-none')
							
							violator.querySelector('.ignore')
								.addEventListener('click', (e) => {
									e.preventDefault();
									violator.classList.add('d-none');
									this.cultureDetectionViolatorsWrap.classList.add('d-none');
									let remember = violator.querySelector('input[type=checkbox]:checked');
									if (remember) {
										const cookieAttributes: CookieAttributes = {
											expires: 150,
											sameSite: "none",
											secure: true
										};
										Cookies.set(cookieKey, "true", cookieAttributes)
									}
								});
						});
					}

				}, (error) => console.warn(error));
				
			}
			

		}
		
		//search autocomplete
		this.initSearchAutocomplete();

		// Sync search-type select to filters param on submit
		this.initSearchTypeFilter();
	}

	private initSearchTypeFilter() {
		const form = this.searchForm as HTMLFormElement;
		if (!form) return;

		form.addEventListener('submit', () => {
			const select = form.querySelector('select[name="search-type"]') as HTMLSelectElement;
			if (!select || select.value === 'All') return;

			// Remove any existing filters input to avoid duplicates
			form.querySelectorAll('input[name="filters"]').forEach(el => el.remove());

			const hidden = document.createElement('input');
			hidden.type = 'hidden';
			hidden.name = 'filters';
			hidden.value = select.value;
			form.appendChild(hidden);
		});
	}

	private initSearchAutocomplete() {
		if (!this.searchBox) return;
		let debounceTimer: number = 0;
		const resultsList = document.querySelector('.nav-autocomplete-list') as HTMLElement;
		const resultsContainer = document.querySelector('.nav-autocomplete-results') as HTMLElement;
		const typeSelect = document.querySelector('.header-search-form select[name="search-type"]') as HTMLSelectElement;

		const doFetch = (value: string) => {
			const culture = Helpers.getCurrentCulture();
			const selectedType = typeSelect?.value ?? 'All';
			const typeParam = selectedType !== 'All' ? `&type=${encodeURIComponent(selectedType)}` : '';
			fetch(`/search/autocomplete?q=${encodeURIComponent(value)}&culture=${encodeURIComponent(culture)}${typeParam}`)
			.then(response => response.json())
			.then(results => {
				if (!resultsList || !resultsContainer) return;
				if (!results || results.length === 0) {
					resultsList.innerHTML = '<li class="no-results"><span>No results found</span></li>';
					resultsContainer.classList.add('open');
					return;
				}
				resultsList.innerHTML = results.map((item: any) =>
					`<li><a href="${item.url.replace('~','')}">
<div class="type">${item.type || ''}</div><div class="title">${item.title || ''}</div><span class="icon">
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M8 7L12 9.99967L8 13" stroke="#7FB350" stroke-width="2"></path><circle cx="10" cy="10" r="9" stroke="#7FB350" stroke-width="2"></circle></svg></span></a></li>`).join('');
				resultsContainer.classList.add('open');
			})
			.catch(err => {
				console.warn('Search autocomplete error:', err);
				if (resultsList) resultsList.innerHTML = '';
				if (resultsContainer) resultsContainer.classList.remove('open');
			});
		};

		this.searchBox.addEventListener('input', () => {
			// Autocomplete is desktop-only
			if (MobileHelpers.isBelowLg()) return;

			const value = this.searchBox.value.trim();
			window.clearTimeout(debounceTimer);

			if (value.length < 2) {
				if (resultsList) resultsList.innerHTML = '';
				if (resultsContainer) resultsContainer.classList.remove('open');
				return;
			}

			if (resultsList) resultsList.innerHTML = '<li class="search-loading"><div class="loader"></div></li>';
			if (resultsContainer) resultsContainer.classList.add('open');

			debounceTimer = window.setTimeout(() => doFetch(value), 300);
		});

		// Re-fetch immediately when content type changes (if search text already present)
		typeSelect?.addEventListener('change', () => {
			if (MobileHelpers.isBelowLg()) return;
			const value = this.searchBox.value.trim();
			if (value.length < 2) return;

			if (resultsList) resultsList.innerHTML = '<li class="search-loading"><div class="loader"></div></li>';
			if (resultsContainer) resultsContainer.classList.add('open');
			doFetch(value);
		});
	}

	openHeaderSearchBox(toggleIfOpen: boolean, addCloseListener = true) {
		if (toggleIfOpen) {
			this.mainHeader.classList.toggle('search-open');
		} else {
			this.mainHeader.classList.add('search-open');
		}
		const isNavOpen = this.mainHeader.classList.contains('search-open');
		const resultsContainer = document.querySelector('.nav-autocomplete-results') as HTMLElement;
		if (!isNavOpen) {
			//nav is closed, remove auto complete
			
			if (resultsContainer) resultsContainer.classList.remove('open');
			this._removeSearchListeners();
		} else if (addCloseListener) {
			const scrollStart = window.scrollY;

			this._searchOutsideClickListener = (e: MouseEvent) => {
				const searchBanner = document.querySelector('.search-banner');
				if (searchBanner && !searchBanner.contains(e.target as Node) && this.mainHeader.classList.contains('search-open')) {
					this.closeSearchBox();
				}
			};

			this._searchScrollListener = () => {
				if (Math.abs(window.scrollY - scrollStart) >= 20) {
					this.closeSearchBox();
				}
			};

			// Defer to avoid the current click (toggle) from immediately triggering the listener
			setTimeout(() => {
				document.addEventListener('click', this._searchOutsideClickListener);
				window.addEventListener('scroll', this._searchScrollListener, { passive: true });
			}, 0);
		}
		
		if (isNavOpen) {
			const resultItemCount = resultsContainer.querySelectorAll('li').length;
			if (resultItemCount > 0) resultsContainer.classList.add('open');
		}
	}

	private _removeSearchListeners() {
		if (this._searchOutsideClickListener) {
			document.removeEventListener('click', this._searchOutsideClickListener);
			this._searchOutsideClickListener = null;
		}
		if (this._searchScrollListener) {
			window.removeEventListener('scroll', this._searchScrollListener);
			this._searchScrollListener = null;
		}
	}

	closeSearchBox(clearInput = false) {
		this.mainHeader?.classList.remove('search-open');
		this.mobileSearchContainer?.classList.remove('open');
		const resultsContainer = document.querySelector('.nav-autocomplete-results') as HTMLElement;
		if (resultsContainer) resultsContainer.classList.remove('open');
		this._removeSearchListeners();
		if (clearInput) {
			if (this.searchBox) this.searchBox.value = "";
			this.searchForm?.querySelector('button')?.classList.remove('typing');
		}
	}

}